export default __webpack_public_path__ + "static/media/3.bde56c5e.png";